export default __webpack_public_path__ + "static/media/relax.d6c72b2d.svg";